import { render } from "./ModalNewRegulation.vue?vue&type=template&id=18cda7b2&scoped=true"
import script from "./ModalNewRegulation.vue?vue&type=script&lang=js"
export * from "./ModalNewRegulation.vue?vue&type=script&lang=js"

import "./ModalNewRegulation.vue?vue&type=style&index=0&id=18cda7b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18cda7b2"

export default script